import { useState, useEffect } from 'react';

const MAX_RECENTLY_VIEWED = 5;

const useRecentlyViewed = () => {
  const [recentlyViewed, setRecentlyViewed] = useState<Array<string>>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('Recently_Viewed');
      return saved ? JSON.parse(saved) : [];
    }
    return [];
  });

  useEffect(() => {
    if (typeof window !== 'undefined' && recentlyViewed.length > 0) {
      localStorage.setItem('Recently_Viewed', JSON.stringify(recentlyViewed));
    }
  }, [recentlyViewed]);
  const addProduct = (sku: string) => {
    setRecentlyViewed((prev) => {
      const updated = prev.filter((item) => item !== sku);

      const newRecentlyViewed = [...updated, sku];

      if (newRecentlyViewed.length > MAX_RECENTLY_VIEWED) {
        newRecentlyViewed.shift();
      }

      return newRecentlyViewed;
    });
  };
  /**
   * Returns a new array with all the items from `recentlyViewed` except for the last one.
   * The last item represents the most recently viewed product, so it is excluded from the result.
   * This is useful when you want to show the previously viewed items, excluding the latest one.
   */
  return { recentlyViewed: recentlyViewed.slice(0, recentlyViewed.length - 1), addProduct };
};

export default useRecentlyViewed;
